import { Button, ButtonGroup, Divider, FormControl, FormLabel, ModalBody, ModalFooter } from "@chakra-ui/react";
import { Form, Modal } from "components";
import { useProduct } from "hooks";
import { useRef } from "react";
import { useParams } from "react-router";

export default function AddLimit({ ...props }){

    const submitRef = useRef()
    const params = useParams()
    const product = useProduct(params?.id)

    return(
    <>
    <Modal title="Adicionar nova restrição" {...props}>
        <ModalBody fontSize="sm">
            Nesta tela você pode configurar a limitação de compra deste produto por núcleos.

            <Divider my={6} />

            <Form.Form submitRef={submitRef} onSubmit={() => {}}>

                <Form.Text 
                    isDisabled
                    label="Produto:"
                    value={product.data?.name}
                />
                
                <Form.Text
                    required
                    type="number"
                    label=""
                    leftAddon="Permitido comprar"
                    rightAddon="unidade(s)"
                    helper="A quantidade de itens permitido comprar no intervalo selecionado."
                />

                <Form.Text
                    required
                    type="number"
                    leftAddon="a cada"
                    rightAddon="dia(s)"
                    helper="O intervalo (em dias) da regra"
                />

                <Divider />

                <FormControl>
                    <FormLabel children="Selecione o período:" />
                    <Form.Interval />
                </FormControl>

            </Form.Form>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm">
                <Button children="Cancelar" />
                <Button children="Adicionar restrição" colorScheme="orange" onClick={() => submitRef.current.click()} />
            </ButtonGroup>
        </ModalFooter>
    </Modal>
    </>
    )
}